import React, { useState } from "react";
import Panels from "./Panels/index";
import Tabs from "./Tabs";
import styles from "./style.module.scss";
import { string } from "prop-types";

export default function Reporter({ reporterTab }) {
  const [tabObj, setTabObj] = useState({
    countSelectedTab: 2,
    box: true,
    "facial landmarks": false,
    issues: true,
  });

  return (
    <div
      className={styles.reporterContainer}
      style={{
        width: reporterTab === "history" ? "400px" : "320px",
        transition: "width 0.3s ease-in-out",
      }}
    >
      <Panels tabObj={tabObj} />
      {false && <Tabs setTabObj={setTabObj} tabObj={tabObj} />}
    </div>
  );
}

Reporter.propTypes = {
  reporterTab: string,
};
